import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTeam } from '../context/TeamContext';
import { useAuth } from '../context/AuthContext';

export default function TeamNewPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loadTeams } = useTeam();
  const { user } = useAuth();
  const [status, setStatus] = useState('loading'); // loading | success | timeout
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (!sessionId || !user) {
      navigate('/team/create', { replace: true });
      return;
    }

    // Poll for team creation — webhook may take a few seconds
    let attempts = 0;
    const maxAttempts = 10;

    const poll = async () => {
      attempts++;
      try {
        await loadTeams();
        // If loadTeams succeeded and we now have teams, navigate there
        setStatus('success');
        setTimeout(() => navigate('/team', { replace: true }), 1500);
      } catch {
        if (attempts < maxAttempts) {
          setTimeout(poll, 1500);
        } else {
          setStatus('timeout');
        }
      }
    };

    // First poll after 2s to give webhook time to fire
    setTimeout(poll, 2000);
  }, [sessionId, user?.id]);

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'var(--font)', flexDirection: 'column', gap: 16, padding: 24,
    }}>
      {status === 'loading' && (
        <>
          <div style={{
            width: 48, height: 48, borderRadius: '50%',
            border: '3px solid var(--border2)',
            borderTopColor: '#7f77dd',
            animation: 'spin 0.8s linear infinite',
          }} />
          <div style={{ fontSize: 18, fontWeight: 500, color: 'var(--text)' }}>Setting up your team...</div>
          <div style={{ fontSize: 13, color: 'var(--muted)' }}>This takes just a moment</div>
        </>
      )}

      {status === 'success' && (
        <>
          <div style={{ fontSize: 52 }}>🎉</div>
          <div style={{ fontSize: 20, fontWeight: 500, color: 'var(--text)' }}>Team created!</div>
          <div style={{ fontSize: 13, color: 'var(--muted)' }}>Taking you to your team dashboard...</div>
        </>
      )}

      {status === 'timeout' && (
        <>
          <div style={{ fontSize: 32 }}>⏳</div>
          <div style={{ fontSize: 18, fontWeight: 500, color: 'var(--text)' }}>Almost there...</div>
          <div style={{ fontSize: 13, color: 'var(--muted)', textAlign: 'center', maxWidth: 340, lineHeight: 1.6 }}>
            Your payment was successful but team setup is taking longer than expected.
            Check your team dashboard in a moment.
          </div>
          <button
            onClick={() => { loadTeams(); navigate('/team', { replace: true }); }}
            style={{
              marginTop: 8, background: '#7f77dd', color: '#fff', border: 'none',
              borderRadius: 10, padding: '11px 24px',
              fontFamily: 'var(--font)', fontSize: 14, fontWeight: 500, cursor: 'pointer',
            }}>
            Go to team dashboard →
          </button>
        </>
      )}

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}